import { useEffect } from 'react';

/**
 * Hook that alerts clicks outside of the passed refs
 * and detects focus changes for third-party iframes.
 * @param {array} actions - array of actions to be executed
 * @param {array} refs - array of refs to be checked
 */
const useClickOutside = (actions = [], refs = [],isActive=true) => {

  useEffect(() => {
    if(!isActive) return;
    const handleClickOutside = (event) => {
      refs.forEach((ref, index) => {
        if (ref.current && !ref.current.contains(event.target)) {
          actions[index](event);
        }
      });
    };

    const handleIframeFocus = (e) => {
      setTimeout(() => {
        if (document.activeElement.tagName === "IFRAME") {
          refs.forEach((_, index) => {
            actions[index](e);
          });
        }
      });
    }

    // Event listeners for mouse and focus events
    document.addEventListener('mousedown', handleClickOutside);
    window.addEventListener("blur",handleIframeFocus , { once: true });

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener('blur', handleIframeFocus, { once: true });
    };
  }, [refs, actions,isActive]);
};

export default useClickOutside;
